/*
  Opus availability — wires the "Check availability at other stores" button in
  the availability module to the pickup drawer that Dawn's pickup-availability.js
  fetches and appends to <body>.

  Two things move independently:
    - the drawer is appended to (and replaced on) document.body, asynchronously
    - the button is re-rendered on every variant change, because product-info.js
      swaps the whole #Inventory-{sectionId} element

  So the click handler is delegated, the drawer is looked up at click time, and
  the button stays hidden until a drawer actually exists. Kept deliberately
  narrow — no document-wide subtree observer on a product page.
*/
(function () {
  const BUTTON_SELECTOR = '.opus-availability__link';

  function getDrawer() {
    return document.querySelector('pickup-availability-drawer');
  }

  function syncButtons() {
    const hasDrawer = Boolean(getDrawer());
    document.querySelectorAll(BUTTON_SELECTOR).forEach((button) => {
      button.toggleAttribute('hidden', !hasDrawer);
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest(BUTTON_SELECTOR);
    if (!button) return;

    const drawer = getDrawer();
    if (!drawer || typeof drawer.show !== 'function') return;

    event.preventDefault();
    drawer.show(button);
  });

  function onReady() {
    syncButtons();

    // The drawer is appended as a direct child of <body>, so a non-subtree
    // observer is enough to catch it mounting and re-mounting.
    if (window.MutationObserver) {
      new MutationObserver(syncButtons).observe(document.body, { childList: true });
    }

    // The button itself is re-rendered by the variant change, after which it
    // needs revealing again.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        requestAnimationFrame(syncButtons);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
